/* unplugin-vue-components disabled */import { render } from "./scrollable-table.vue?vue&type=template&id=021b11ec&scoped=true"
import script from "./scrollable-table.vue?vue&type=script&lang=js"
export * from "./scrollable-table.vue?vue&type=script&lang=js"

import "./scrollable-table.vue?vue&type=style&index=0&id=021b11ec&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021b11ec"],['__file',"src/components/data-table/scrollable-table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "021b11ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('021b11ec', __exports__)) {
    api.reload('021b11ec', __exports__)
  }
  
  module.hot.accept("./scrollable-table.vue?vue&type=template&id=021b11ec&scoped=true", () => {
    api.rerender('021b11ec', render)
  })

}


export default __exports__